import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";
import { fetcher } from "../src/utils/fetcher";

export default class extends Controller {
  static values = { param: String, serviceId: Number };
  static targets = ["tweetButton"];

  connect() {
    this.showIfSetParams();

    // モーダルを閉じた時に自動で表示されないように、クエリパラメータを削除する
    this._onHidden = () => this.clearQuery();
    this.element.addEventListener("hidden.bs.modal", this._onHidden);
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this._onHidden);
  }

  showIfSetParams() {
    if (!this.hasParamValue) return;

    const params = new URLSearchParams(window.location.search);
    const val = (params.get(this.paramValue) || "").toLowerCase();
    if (val !== "true") return;

    Modal.getOrCreateInstance(this.element).show();
  }

  async tweet() {
    if (this.isSubmitting) return;
    if (!this.hasServiceIdValue) {
      console.error("[tweet] serviceIdが存在しません。");
      return;
    }

    // ボタンをローディング表示にするためにHTML・CSSを上書きする
    // API通信完了後にfinallyで元に戻す必要がある
    const originalContent = this.tweetButtonTarget.innerHTML;
    const originalMinWidth = this.tweetButtonTarget.style.minWidth;
    this.tweetButtonTarget.style.minWidth = `${this.tweetButtonTarget.offsetWidth}px`;
    this.tweetButtonTarget.disabled = true;
    this.tweetButtonTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>送信中...';

    this.isSubmitting = true;
    try {
      const { data } = await fetcher.post(`/api/internal/v1/services/${this.serviceIdValue}/tweet`);
      this.clearQuery();
      Modal.getInstance(this.element)?.hide();
      this.showDoneModal(data.tweetUrl);
    } catch {
      alert("つぶやきの投稿に失敗しました。時間をおいて再度お試しください。");
    } finally {
      this.tweetButtonTarget.innerHTML = originalContent;
      this.tweetButtonTarget.style.minWidth = originalMinWidth;
      this.tweetButtonTarget.disabled = false;
      this.isSubmitting = false;
    }
  }

  showDoneModal(tweetUrl) {
    const doneModal = document.getElementById("postTweetDoneModal");
    const link = document.getElementById("postTweetDoneLink");
    if (link && tweetUrl) {
      link.href = tweetUrl;
    }
    Modal.getOrCreateInstance(doneModal).show();
  }

  clearQuery() {
    if (!this.hasParamValue) return;

    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramValue);
    window.history.replaceState({}, "", url.toString());
  }
}
